<div class="rdo-configured-column-selector dropdown column-selector-container" style="overflow:visible">
  <a id="dLabel" class="btn btn-primary btn-inverse column-selector-link" (click)="showDropDown = !showDropDown">
    <i class="fa fa-fw fa-columns column-selector-icon" [ngClass]="{'fa-lg': size === 'md'}">
    </i>&nbsp;{{handleTranslation('main.core.tables.common.select_columns')}}
  </a>

  <ul class="dropdown-menu pull-right column-selector-list" [style.display]="showDropDown ? 'inline' : 'none'" id="dLabelDropdown">
    @for (li of elements; track li) {
      @if (li.isHeader && !li.hidden) {
        <li class="dropdown-header column-selector-li"
          id="{{(li.title || li.columnSelectorTitle) | rdoPathToId:'list-selector'}}">
          {{handleTranslation(li.title)}}
        </li>
      }
      @if (li.type === 'column') {
        <li class="column-selector-li">
          <a (click)="toggleVisibility($event,li)" class="column-selector-link"
            id="{{(li.title) | rdoPathToId:'list-selector'}}">
            <i class="fa fa-fw" [ngClass]="{'fa-check':li.target?.visible}"></i>
            {{ handleTranslation(li.title )}}
          </a>
        </li>
      }
      @if (li.type === 'group' && (!li.target?.locked || li.target?.forceCanClose) && !li.target?.hidden) {
        <li class="column-selector-li">
          <a (click)="toggleVisibility($event,li)" class="column-selector-link"
            id="{{(li.title || li.target?.columnSelectorTitle) | rdoPathToId:'list-selector'}}">
            <i class="fa fa-fw" [ngClass]="{'fa-check':li.target?.visible}"></i>
            {{ handleTranslation(li.title ||  li.target?.columnSelectorTitle)}}
          </a>
        </li>
      }
    }
  </ul>

  @if (authenticationService._userInfoView.HasClientAccessToExportData) {
    <button id="download-excel-button"
      (click)="clickExcelDownload($event,g); showDropDown = false;" class="btn btn-success btn-inverse">
      <i class="fa fa-fw fa-file-excel-o" [ngClass]="{'fa-lg': size === 'md'}"></i>&nbsp;
    {{'main.core.tables.common.excel' | translate}}</button>
  }
  @if (gridConfig.enableDelete) {
    <button [disabled]="gridConfig.disableDeleteButton"
      (click)="clickDelete($event,g)" class="btn btn-danger btn-inverse">
      <i class="fa fa-fw fa-trash-o"></i>&nbsp;
    {{'main.core.tables.common.delete' | translate}}</button>
  }
</div>
